import { QueryClientProvider } from '@tanstack/react-query'
import { Suspense, lazy } from 'react'
import { AppRouter } from './AppRouter'
import QueryErrorBoundary from './components/common/QueryErrorBoundary'
import { Toaster } from './components/ui/toaster'
import AuthProvider from './contexts/AuthProvider'
import queryClient from './services/api/queryClient'
import { DEBUG } from './services/supabase/env'

// Lazy load React Query Devtools in development
const ReactQueryDevtools = lazy(() =>
  DEBUG
    ? import('@tanstack/react-query-devtools').then((mod) => ({
        default: mod.ReactQueryDevtools,
      }))
    : Promise.resolve({ default: () => null }),
)

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <Toaster />
      <QueryErrorBoundary>
        <AuthProvider>
          <AppRouter />
        </AuthProvider>
        {DEBUG && (
          <Suspense>
            <ReactQueryDevtools initialIsOpen={false} />
          </Suspense>
        )}
      </QueryErrorBoundary>
    </QueryClientProvider>
  )
}

export default App
